export default [
  {
    path: '/console',
    component: () => import('@/views/console/index.vue')
  }
]
